import { Col, Form, Row } from "antd";
import { MazakaForm } from "apps/Common/MazakaForm";
import { MazakaInput } from "apps/Common/MazakaInput";
import useMazakaForm from "hooks/useMazakaForm";
import { GeneralAddOrUpdateFormProps } from "models/Client/GeneralAddOrUpdate";
import { FC, useEffect } from "react";
import { addFavoriteList, updateFavoriteList } from "../Services";
import GeneralNotificationTypes from "apps/Common/NotificationTypes/GeneralNotificationTypes";

const AddOrUpdateFavoriteList: FC<GeneralAddOrUpdateFormProps> = ({
  selectedRecord,
  onFinish,
}) => {
  const [form] = Form.useForm();
  const { mazakaForm, formActions } = useMazakaForm(form);
  useEffect(() => {
    if (selectedRecord) {
      let data = {...selectedRecord}
      data["notificationTypeIdList"]= selectedRecord?.notificationTypeFavoriteList?.map((item:any)=>item.notificationTypeId)
      form.setFieldsValue({ ...data });
    }
  }, [selectedRecord]);

  const handleOnFinish = async()=>{
    mazakaForm.setLoading()
    let formValues = form.getFieldsValue()
    let response = {}
    try {
        if(selectedRecord)
        {
           
          await updateFavoriteList({...selectedRecord,...formValues})
        }
        else{
          response = await addFavoriteList(formValues)
        }
        form.resetFields()
        onFinish(response)
        mazakaForm.setSuccess(2000,()=>"İşlemBaşarılı")
     
    } catch (error:any) {
        mazakaForm.setFailed(2500,error?.message)
        console.log("somethings wrong during add or update favorite list")
    }
  }
  return (
    <>
      <Col xs={24}>
        <MazakaForm onFinish={handleOnFinish} form={form} {...formActions}>
          <Row gutter={[0,10]}>
            <MazakaInput
              rules={[{ required: true, message: "" }]}
              label={"Adı"}
              xs={24}
              name={"name"}
              placeholder="Adı"
            />
            <GeneralNotificationTypes
             rules={[{ required: true, message: "" }]}
             label={"Bildirim Yolları"}
             xs={24}
             name={"notificationTypeIdList"}
             placeholder="Bildirim Yolları"
             mode="multiple"
            />
          </Row>
        </MazakaForm>
      </Col>
    </>
  );
};

export default AddOrUpdateFavoriteList;
